// Downcase and replace whitespace with dash
export const slugify = (s?: string, separator = "-"): string =>
  !s ? "" : s.toLowerCase().replace(/\s+/g, separator);

export const toTitleCase = (s?: string) =>
  s.replace(/\w\S*/g, (text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase());

export const isHtmlContentEmpty = (html: string) =>
  html
    .replace(/(<([^>]+)>)/gi, "")
    .trim()
    .replace(/\u200B/g, "") === "";

export const addProtocolIfNotExists = (url: string, protocol = "https") => {
  if (url.search("://") >= 0) {
    return url;
  }
  if (url.startsWith("//")) {
    return `${protocol}${url}`;
  }
  return `${protocol}://${url}`;
};

export const stripTags = (html) => {
  let doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};

type LexicalJoinType = "conjunction" | "disjunction";
export const lexicalJoin = (list: string[], fmt: LexicalJoinType = "conjunction"): string => {
  // @ts-ignore
  const formatter = new Intl.ListFormat("en", { style: "long", type: fmt });
  return formatter.format(list);
};

export const lexicalJoinAndOr = (list: string[]): string => {
  const end = list.pop();
  let str = "";
  if (list.length > 0) {
    const oxfordComma = list.length > 1 ? "," : "";
    str = `${list.join(", ")}${oxfordComma} and/or `;
  }
  str += end;
  return str;
};

export const truncateAtWordBoundary = (str: string, maxChars: number): string => {
  if (str.length <= maxChars) return str;
  const lastSpace = str.substring(0, maxChars).lastIndexOf(" ");
  return str.substring(0, lastSpace);
};

export const truncateWithEllipsis = (str: string, maxChars: number): string => {
  if (str.length <= maxChars) return str;
  return str.substring(0, maxChars) + "...";
};
